import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M10.0999 47.6999C14.2299 43.7399 12.08 36.7999 12.08 36.7999C15.38 30.3599 11.9099 26.89 11.9099 26.89C16.0399 20.45 12.24 15.6599 12.24 15.6599C16.53 9.71987 12.07 3.76986 12.07 3.76986C12.07 3.76986 7.05995 -0.550072 3.22995 3.83993C3.22995 3.83993 -0.730002 10.1299 4.03 15.6999C4.03 15.6999 0.629988 20.78 5.26999 26.87C5.26999 26.87 2.09994 30.61 5.90994 36.76C5.90994 36.76 4.32999 43.8499 8.76999 47.4599L10.0999 47.6999Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M39.4001 47.6999C35.2701 43.7399 37.42 36.7999 37.42 36.7999C34.12 30.3599 37.5901 26.89 37.5901 26.89C33.4601 20.45 37.2601 15.6599 37.2601 15.6599C32.9701 9.71987 37.43 3.76986 37.43 3.76986C37.43 3.76986 42.4401 -0.550072 46.2701 3.83993C46.2701 3.83993 50.23 10.1299 45.47 15.6999C45.47 15.6999 48.87 20.78 44.23 26.87C44.23 26.87 47.4001 30.61 43.5901 36.76C43.5901 36.76 45.17 43.8499 40.73 47.4599L39.4001 47.6999Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
